/** URL `?tab=` values for material request overview. */
export const MaterialRequestOverviewTabParam = {
  OVERVIEW: "overview",
} as const;

export type MaterialRequestOverviewTabParamValue =
  (typeof MaterialRequestOverviewTabParam)[keyof typeof MaterialRequestOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, MaterialRequestOverviewTabParamValue> = {
  "1": MaterialRequestOverviewTabParam.OVERVIEW,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [MaterialRequestOverviewTabParam.OVERVIEW]: "1",
  // Legacy param — line items moved into an accordion on the Overview tab.
  "line-items": "1",
};

export function materialRequestOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForMaterialRequestOverviewTabId(
  tabId: string,
): MaterialRequestOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidMaterialRequestOverviewTabParam(
  tab: string | null,
): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
